import { gql } from "apollo-boost";

const employees = gql`
  {
    employees {
      id
      email
      name
      title
      firstName
      lastName
      roles
      poolInfo {
        enabled
        status
        createDate
        lastModifiedDate
      }
    }
    authRoles {
      id
      name
    }
  }
`;
export const employee = gql`
  query employee($id: String!) {
    employee(id: $id) {
      id
      email
      title
      name
      firstName
      lastName
      roles
      poolInfo {
        enabled
        status
      }
    }
  }
`;

const saveEmployee = gql`
  mutation saveEmployee($input: SaveEmployeeInput!) {
    saveEmployee(input: $input)
  }
`;

export const ResendEmployee = gql`
  mutation resendEmployee($id: String!) {
    resendEmployee(id: $id)
  }
`;

export const SetEmployeeEnable = gql`
  mutation setEmployeeEnable($id: String!, $enabled: Boolean!) {
    setEmployeeEnable(id: $id, enabled: $enabled)
  }
`;

export const employeeGql = { employees, employee, saveEmployee, ResendEmployee, SetEmployeeEnable };
